import { loadSchema } from './loadSchema';

/**
 * This is an optional dependency to start with due to the weight it adds.
 *
 * To exclude ajv from your bundle simply add it to webpack's externals list and don't include it in your host document
 */
export function getAjv() {
    try {
        // Must be imported this way as it's an optional dependency
        const Ajv = require('ajv'); // eslint-disable-line global-require
        return new Ajv({
            loadSchema
        });
    } catch (e) {} // eslint-disable-line no-empty
}
